import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { MenuItem, Select, TextField, InputLabel, FormControl, Autocomplete, Box } from "@mui/material";
import { OCPP_MESSAGES_1_6 } from "../../../pages/ocpp_messages/constants";
import { LABELS, MESSAGE_TYPES } from "./constants";
import "./filterbar.scss";
import Icon from "../Icons/Icon";

export default function AdvancedFilters({
  messageType,
  feature,
  details,
  onMessageTypeChange,
  onFeatureChange,
  onDetailSearch,
}) {
  const size = { width: 30, height: 30 };
  const featureOptions = useMemo(() => {
    const features = Object.keys(OCPP_MESSAGES_1_6 || {});
    return [LABELS.ANY_FEATURE, ...features];
  }, []);

  return (
    <Box display="flex" gap={2} flexWrap="wrap" className="adv-filters">
      {/* Message Type */}
      <FormControl size="small" sx={{ minWidth: 300 }}>
        <InputLabel id="adv-type-label">{LABELS.MESSAGE_TYPE}</InputLabel>
        <Select
          labelId="adv-type-label"
          value={messageType || ""}
          label={LABELS.MESSAGE_TYPE}
          onChange={e => onMessageTypeChange?.(e.target.value)}
          renderValue={val => (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              {val === MESSAGE_TYPES.CLOUD_INCOMING_CALL && <Icon src="CloudIncomingIcon" {...size} fill="#3B82F6" />}
              {val === MESSAGE_TYPES.CLOUD_INCOMING_ERROR && <Icon src="CloudIncomingIcon" {...size} fill="#DC2626" />}
              {val === MESSAGE_TYPES.CLOUD_INCOMING_REQUEST && (
                <Icon src="CloudIncomingIcon" {...size} fill="#16A34A" />
              )}
              {val === MESSAGE_TYPES.CLOUD_OUTGOING_CALL && <Icon src="CloudOutgoingIcon" {...size} fill="#3B82F6" />}
              {val === MESSAGE_TYPES.CLOUD_OUTGOING_ERROR && <Icon src="CloudOutgoingIcon" {...size} fill="#DC2626" />}
              {val === MESSAGE_TYPES.CLOUD_OUTGOING_REQUEST && (
                <Icon src="CloudOutgoingIcon" {...size} fill="#16A34A" />
              )}
              <span>{val ? val[0].toUpperCase() + val.slice(1) : LABELS.ANY}</span>
            </span>
          )}
        >
          <MenuItem value="">{LABELS.ANY}</MenuItem>
          {/* CLOUD INCOMING */}
          <MenuItem value={MESSAGE_TYPES.CLOUD_INCOMING_CALL}>
            <Icon src="CloudIncomingIcon" width={30} height={30} fill="#3B82F6" style={{ marginRight: 8 }} />
            Cloud Incoming Call
          </MenuItem>

          <MenuItem value={MESSAGE_TYPES.CLOUD_INCOMING_ERROR}>
            <Icon src="CloudIncomingIcon" width={30} height={30} fill="#DC2626" style={{ marginRight: 8 }} />
            Cloud Incoming Error
          </MenuItem>

          <MenuItem value={MESSAGE_TYPES.CLOUD_INCOMING_REQUEST}>
            <Icon src="CloudIncomingIcon" width={30} height={30} fill="#16A34A" style={{ marginRight: 8 }} />
            Cloud Incoming Request
          </MenuItem>

          {/* CLOUD OUTGOING */}
          <MenuItem value={MESSAGE_TYPES.CLOUD_OUTGOING_CALL}>
            <Icon src="CloudOutgoingIcon" width={30} height={30} fill="#3B82F6" style={{ marginRight: 8 }} />
            Cloud Outgoing Call
          </MenuItem>
          <MenuItem value={MESSAGE_TYPES.CLOUD_OUTGOING_ERROR}>
            <Icon src="CloudOutgoingIcon" width={30} height={30} fill="#DC2626" style={{ marginRight: 8 }} />
            Cloud Outgoing Error
          </MenuItem>

          <MenuItem value={MESSAGE_TYPES.CLOUD_OUTGOING_REQUEST}>
            <Icon src="CloudOutgoingIcon" width={30} height={30} fill="#16A34A" style={{ marginRight: 8 }} />
            Cloud Outgoing Request
          </MenuItem>
        </Select>
      </FormControl>

      {/* Feature */}
      <Autocomplete
        multiple
        size="small"
        sx={{ minWidth: 200 }}
        fullWidth={false}
        options={featureOptions}
        value={feature || []}
        onChange={(e, newVal) => {
          onFeatureChange?.(newVal);
        }}
        renderInput={params => (
          <TextField {...params} label={LABELS.FEATURE} placeholder={LABELS.SEARCH_FEATURE_PLACEHOLDER} />
        )}
        autoHighlight
        clearOnBlur={false}
        openOnFocus
      />

      {/* Message Search */}
      <TextField
        size="small"
        placeholder={LABELS.SEARCH_MESSAGE_PLACEHOLDER}
        value={details || ""}
        onChange={e => onDetailSearch?.(e.target.value)}
        sx={{ minWidth: 200 }}
      />
    </Box>
  );
}

AdvancedFilters.propTypes = {
  messageType: PropTypes.string,
  feature: PropTypes.array,
  details: PropTypes.string,
  onMessageTypeChange: PropTypes.func,
  onFeatureChange: PropTypes.func,
  onDetailSearch: PropTypes.func,
};
